export const getS3RoleAccessSetupCloudFormationTemplateUrl =
  'getS3RoleAccessSetupCloudFormationTemplateUrl';
